import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import CategoryTab from "./CategoryTab";

function Category () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CategoryTab />
      <Footer />
    </DashboardLayout>
  );
}

export default Category;
